const translations = {
  fr: {
    registration: {
      registrationPageTitle: 'Inscription',
      invitationSuccess: 'Invitation acceptée',
      invitationSuccessMessage: 'Bienvenue chez StatsRadio, vous serez redirigé vers la page de connexion...',
      invalidInvitation: 'Invitation invalide',
      invalidInvitationMessage: 'Désolé, votre invitation est expirée ou a déjà été acceptée.',
      invalidInvitationContactMessage: 'Veuillez contacter la personne qui vous a invité à StatsRadio pour recevoir une nouvelle invitation.',
      goBack: 'Retour',
    },
  },
  en: {
    registration: {
      registrationPageTitle: 'Inscription',
      invitationSuccess: 'Invitation accepted',
      invitationSuccessMessage: 'Welcome to StatsRadio, you will be redirected to the login page...',
      invalidInvitation: 'Invalid invitation',
      invalidInvitationMessage: 'Your invitation may have expired or was already accepted.',
      invalidInvitationContactMessage: 'Please contact the person who invited you to StatsRadio to receive a new invitation.',
      goBack: 'Go back',
    },
  },
};

export default translations;



// WEBPACK FOOTER //
// ./src/statsradio/modules/registration/i18n/registration.js